import { ICognitoStorage } from "amazon-cognito-identity-js";
import SecureLS from "secure-ls";

const activeEnv = process.env.GATSBY_ENV || process.env.NODE_ENV || "development";

const dotEnvResult = require("dotenv").config({
  path: `.env.${activeEnv}`,
});

if (dotEnvResult.parsed) {
  Object.assign(process.env, dotEnvResult.parsed);
}

// Below AuthStorage config uses the secure-ls encrypted local storage module to encrypt all
// Cognito user data so no internal ids or other identifying information are visible on the client
const encryptedLocalStorage = new SecureLS();
const AuthStorage: ICognitoStorage = {
  setItem: (key: string, value: any): void => encryptedLocalStorage.set(key, value),
  getItem: (key: string): any => encryptedLocalStorage.get(key),
  removeItem: (key: string): void => encryptedLocalStorage.remove(key),
  clear: (): void => encryptedLocalStorage.removeAll(),
};

export const amplifyConfig = {
  storage: AuthStorage,
  Auth: {
    authenticationFlowType: "USER_PASSWORD_AUTH",
    identityPoolId: process.env.GATSBY_COGNITO_IDENTITY_POOL_ID,
    region: process.env.GATSBY_REGION,
    userPoolId: process.env.GATSBY_COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.GATSBY_COGNITO_USER_POOL_WEB_CLIENT_ID,
    oauth: {
      domain: process.env.GATSBY_COGNITO_OAUTH_DOMAIN,
      scope: ["phone", "email", "openid", "profile", "aws.cognito.signin.user.admin"],
      redirectSignIn: process.env.GATSBY_SOCIAL_SIGN_IN_REDIRECT_URL,
      redirectSignOut: process.env.GATSBY_SOCIAL_SIGN_OUT_REDIRECT_URL,
      responseType: "code",
    },
  },
};
